import { RECEIPT_PAYMENT_MODE_ID } from "@elixir/types";
import { Popover } from "antd";
import React from "react";
import { ReactComponent as ChevronDownRegularIcon } from "../../assets/icons/chevron-down-regular.svg";
import {
  PAY_MODES,
  TPaymodeArrayObject,
  TPaymodeObject,
} from "../../constants/receipt";
import { TReceiptPayment } from "../../types/appointment";
import { TReceiptEntity } from "../../types/billing";

const PaymodeOptions = ({
  onPaymodeClick,
}: {
  onPaymodeClick: (mode: TPaymodeArrayObject) => void;
}) => {
  return (
    <div className="min-w-208 max-w-208">
      <div className="text-10 font-400 leading-5 text-neutral-4 px-18">
        Select an option
      </div>
      {PAY_MODES.map(mode => {
        if (!mode.isActive) return null;
        return (
          <div
            className="text-12 font-400 leading-6 text-neutral-2 cursor-pointer hover:bg-darwin-neutral-100 px-18"
            key={mode.id}
            onClick={() => onPaymodeClick(mode)}
          >
            {mode.name}
          </div>
        );
      })}
    </div>
  );
};

const PaymodeField = ({
  receiptEntity,
  isDisabled,
  onPaymodeSelect,
}: {
  receiptEntity: TReceiptEntity;
  isDisabled: boolean;
  onPaymodeSelect: (newReceiptEntity: TPaymodeObject) => void;
}) => {
  const [showPopup, setShowPopup] = React.useState<boolean>(false);

  const { paymentItems } = receiptEntity;
  const { paymode } = paymentItems?.[0] || {};

  const paymodeName = React.useMemo(
    () => PAY_MODES.find(mode => mode.id === paymode)?.name || "Paymode",
    [paymode]
  );

  if (isDisabled) {
    return (
      <div className="flex items-center justify-between border rounded-2 border-darwin-neutral-100 w-full px-8 py-7 bg-darwin-neutral-50 text-darwin-neutral-600">
        <div>
          {paymentItems?.length > 1
            ? "Multiple"
            : paymode
            ? paymode === RECEIPT_PAYMENT_MODE_ID.EKA_POSTPAY
              ? "Eka Payment"
              : paymode === RECEIPT_PAYMENT_MODE_ID.EKA_PREPAID
              ? "Eka Prepaid"
              : PAY_MODES.find(mode => mode.id === paymode)?.name || paymode
            : "Paymode"}
        </div>
        <ChevronDownRegularIcon className="w-16 h-16 text-darwin-neutral-900" />
      </div>
    );
  }

  const handlePaymodeClick = (payment: TPaymodeArrayObject) => {
    const newPaymentItem: TReceiptPayment = {
      amount: receiptEntity?.paymentItems?.[0]?.amount || 0,
      paymode: payment.id,
    };
    onPaymodeSelect(newPaymentItem);
    setShowPopup(false);
  };

  return (
    <Popover
      visible={showPopup}
      onVisibleChange={visibility => {
        setShowPopup(visibility);
      }}
      content={<PaymodeOptions onPaymodeClick={handlePaymodeClick} />}
      trigger={"click"}
      placement="bottom"
      overlayInnerStyle={{ borderRadius: "4px", padding: "8px 0px" }}
      overlayClassName="popover-p-0"
    >
      <div
        className={`flex items-center justify-between border rounded-2 border-darwin-neutral-100 w-full px-8 py-7 cursor-pointer ${
          isDisabled
            ? "bg-darwin-neutral-50 text-darwin-neutral-600"
            : "bg-neutral-0"
        }`}
      >
        <div>{paymodeName}</div>
        <ChevronDownRegularIcon className="w-16 h-16 text-darwin-neutral-900" />
      </div>
    </Popover>
  );
};

export default PaymodeField;
